import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LoginUser } from '../../types/model/user';
import { initialUserValue } from '../initial-state';

export const USER_READ_STORE_NAME = 'userRead';

export type UserReadState = {
  entity: LoginUser
  accessToken: string
  refreshToken: string
  refreshInterval: number
  idToken: string
  loaded: boolean
  error?: any
}

export const initialUserReadState: UserReadState = {
  entity: initialUserValue,
  accessToken: '',
  refreshToken: '',
  refreshInterval: 0,
  idToken: '',
  loaded: false,
  error: null,
};

export const userReadSlice = createSlice({
  name: USER_READ_STORE_NAME,
  initialState: initialUserReadState,
  // awaitでないAction系
  reducers: {
    setUserInfo: (state, action: PayloadAction<LoginUser>) => {
      state.entity = action.payload;
      state.loaded = true;
    },
    setAccessToken: (state, action: PayloadAction<string>) => {
      state.accessToken = action.payload;
    },
    setRefreshToken: (state, action: PayloadAction<string>) => {
      state.refreshToken = action.payload;
    },
    setRefreshInterval: (state, action: PayloadAction<number>) => {
      state.refreshInterval = action.payload;
    },
    setIdToken: (state, action: PayloadAction<string>) => {
      state.idToken = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const userReadActions = {
  ...userReadSlice.actions,
};

export default userReadSlice.reducer;
